import React from "react";

const CardMC = ({
  children,
  className = '',
  onClick
}) => (
  <div className={`tw-flex tw-border tw-border-gray-200 tw-rounded-xl ${className}`} onClick={onClick}>
    {children}
  </div>
);
export default CardMC;
